import React from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import APP_CONFIG from "../../../../../config/appConfig";
// import ReviewComponent from "../../../../HtmlElements/ReviewComponent";
// import { fetchReviewSectionEntityList } from "../../../../../services/commonService";
// import { useParams } from "react-router-dom";

function ContactPsycikModal({ data, show, onClose }) {

  return (
    <Modal
      show={show}
      size="lg"
      onHide={onClose}
      className="contact_modal_wrapper"
      centered
    >
      <Modal.Header closeButton>
        <div className="contact_modal_header_block">
          <div className="Key_icon_block">
            <img
              className="contact_icon_img"
              src={`${
                APP_CONFIG.AVATAR_URL
              }background=ed40407a&color=fff&name=${
                data?.contact_name
                  ? data.contact_name
                  : data?.first_name + " " + data?.last_name
              }&rounded=true&bold=true&font-size=0.50&font-family=inter`}
              alt="Avatar"
            />
          </div>

          <div className="name_linkedin">
            <h5 className="name">
           
                <>
                  {/* <span>{data?.first_name + " " + data?.middle_name + " "+ data?.last_name}</span> */}
                  <span>
                    {(data?.contact_name || "") +
                      " " +
                      (data?.middle_name || "") +
                      " " +
                      (data?.last_name || "")}
                  </span>

                  <a
                    href={data?.linkedin_profile}
                    rel="noopener noreferrer"
                    target="_blank"
                    className="linkedin"
                  >
                    <i className="fa fa-linkedin-square" aria-hidden="true"></i>
                  </a>
                </>
           
            </h5>
            <div className="d-flex justify-content-between align-items-center1">
              {data.role
                ? data.role
                : data.role && (
                    <p className="designation">
                      <span className="designation_span">{data.role}</span>
                    </p>
                  )}

            </div>
            
          </div>
        </div>
      </Modal.Header>

      <Modal.Body>
                <div className="row">
                    <div className="col-md-12">
                        <div className='hook_block_wrapper'>
                            {data?.psychographic_profile_summary && <div className="col-md-12 hook_block">
                                <div className='hook_head'>
                                    <h5 className='hook_head'><span className='hook_subhead'>Psychographic Summary</span></h5>
                                    <p className='hook_para'>
                                        {data?.psychographic_profile_summary ? data?.psychographic_profile_summary : data?.psychographic_profile_summary}
                                    </p>
                                </div>
                            </div>}
                            <div className='row'>
                                <div className='col-md-8'>
                                    {data?.focus_areas?.hook1 && (<div className='hook_block'>
                                        <h5 className='hook_head'><span className='hook_subhead'>Hook 1</span></h5>
                                        <p className='hook_para'>
                                            {data?.focus_areas?.hook1.replace(/^['"]|['"]$/g, '')}
                                        </p>
                                    </div>)}

                                    {data?.focus_areas?.hook2 && (<div className='hook_block'>
                                        <h5 className='hook_head'><span className='hook_subhead'>Hook 2</span></h5>
                                        <p className='hook_para'>
                                            {data?.focus_areas?.hook2}
                                        </p>
                                    </div>)}
                                </div>
                                {(data?.focus_areas?.breaking_the_ice || data?.focus_areas?.breaking?.the?.ice)  && (<div className='col-md-4'>
                                    <div className='ice_block'>
                                        <h5 className='ice_head'>
                                            <img src="/img/icons/ice.png" className='ice_icon' alt="ice_icon"/>  
                                            Breaking the Ice                      
                                        </h5>
                                        <p className='ice_para'>
                                            {(data?.focus_areas?.breaking?.the?.ice) ? (data?.focus_areas?.breaking?.the?.ice) : (data?.focus_areas?.breaking_the_ice)  }
                                        </p>
                                    </div>
                                </div>)}
                            </div>


                        </div>
                    </div>
                </div>
                </Modal.Body>
    </Modal>
  );
}

ContactPsycikModal.propTypes = {
  data: PropTypes.shape({
    profileImage: PropTypes.string,
    name: PropTypes.string.isRequired,
    rating: PropTypes.number,
    reviewCount: PropTypes.number,
  }).isRequired,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ContactPsycikModal;
